import styles from "./AnalyticsSectionHeader.module.scss";

type Props = {
	/** The section's place in the page, e.g. "01" — passed already padded. */
	number: string;
	title: string;
};

/** The heading a section of an analytics page carries, above its widgets. */
const AnalyticsSectionHeader = ({ number, title }: Readonly<Props>) => (
	<div className={styles.header}>
		<div className={styles.number}>{number}</div>
		<h2 className={styles.title}>{title}</h2>
		<hr className={styles.line} />
	</div>
);

export default AnalyticsSectionHeader;
